export default ['router', 'formResult', 'api'];
